import Cropper from "react-cropper";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import Input from "react-phone-number-input/input";
import ListItemText from "@mui/material/ListItemText";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useRef, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { UserCloseIcon, UserIcon } from "../../pages/logged_in/Advisor/ClientIndex/Team.js";
import BusinessCards from "../../pages/logged_in/Advisor/BusinessCards.js";
import { hasValidAdvisor } from "../../pages/logged_in/Advisor/BusinessCards.js";
import { postRequest, showMessage, getRequest } from "../../config";
import { toggleModal } from "../../reducers/modalReducer";
import "react-circular-progressbar/dist/styles.css";

const cropper = React.createRef(null);

const UploadSection = ({ advisorData, profileClass, onProfileImageHandler }) => {
    return (
        <div className="form-group df jsc">
            <div className="img-upload-area pr">
                <div className="img-box pr shadow">
                    <img src={advisorData?.profile || require("../../../images/profile-photo.jpeg")} alt="Profile"
                        className={`profile-img w7rem h7rem ${profileClass}`} />
                    <div className="input-file">
                        <span
                            className="add-btn bg5"
                            onClick={onProfileImageHandler}
                        >
                            <svg viewBox="0 0 487 487" className="zi3">
                                <g>
                                    <path
                                        d="M308.1,277.95c0,35.7-28.9,64.6-64.6,64.6s-64.6-28.9-64.6-64.6s28.9-64.6,64.6-64.6S308.1,242.25,308.1,277.95z
                                        M440.3,116.05c25.8,0,46.7,20.9,46.7,46.7v122.4v103.8c0,27.5-22.3,49.8-49.8,49.8H49.8c-27.5,0-49.8-22.3-49.8-49.8v-103.9
                                        v-122.3l0,0c0-25.8,20.9-46.7,46.7-46.7h93.4l4.4-18.6c6.7-28.8,32.4-49.2,62-49.2h74.1c29.6,0,55.3,20.4,62,49.2l4.3,18.6H440.3z
                                        M97.4,183.45c0-12.9-10.5-23.4-23.4-23.4c-13,0-23.5,10.5-23.5,23.4s10.5,23.4,23.4,23.4C86.9,206.95,97.4,196.45,97.4,183.45z
                                        M358.7,277.95c0-63.6-51.6-115.2-115.2-115.2s-115.2,51.6-115.2,115.2s51.6,115.2,115.2,115.2S358.7,341.55,358.7,277.95z"
                                    />
                                </g>
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

const EDIT_FORM = [
    {
        identifier: 'firstName', type: 'text', placeholder: 'First Name', className: "pl4rem shadow bg5 w100 br5px p1rem",
        index: 0,
        svg: <svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 640 512">
            <path d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z" className="fa-secondary"></path>
        </svg >
    },
    {
        identifier: 'lastName', type: 'text', placeholder: 'Last Name', className: "pl4rem shadow bg5 w100 br5px p1rem",
        index: 1,
        svg: <svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 640 512">
            <path
                d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z"
                className="fa-secondary"
            ></path>
        </svg>
    },
    {
        identifier: 'email', type: 'email', placeholder: 'Email', className: "pl4rem shadow bg5 w100 br5px p1rem", disabled: true,
        index: 2,
        svg: <svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 512 512">
            <path
                d="M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z"
                className="fa-secondary"
            ></path>
            <path
                d="M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z"
                className="fa-primary"
            ></path>
        </svg>,
    },
    {
        identifier: 'phone', type: 'text', country: "GB", international: true, withCountryCallingCode: true, placeholder: 'First Name', className: "bg5 w100 pl4rem shadow br5px p1rem",
        index: 3,
        svg: <svg className="center-vertically f3 pa l0 ml1rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
            <path
                className="fa-primary"
                d="M352 48V384H32V48C32 21.5 53.5 0 80 0h224C330.5 0 352 21.5 352 48z"
            />
            <path
                className="fa-secondary"
                d="M32 384v80C32 490.5 53.5 512 80 512h224c26.5 0 48-21.5 48-48V384H32zM240 447.1C240 456.8 232.8 464 224 464H159.1C151.2 464 144 456.8 144 448S151.2 432 160 432h64C232.8 432 240 439.2 240 447.1z"
            />
        </svg>,
        component: "phone-input"
    },
    {
        identifier: 'linkedIn', type: 'text', placeholder: 'LinkedIn', className: "bg5 pl4rem shadow w100 br5px p1rem",
        index: 4,
        svg: <svg
            className="center-vertically f3 pa l0 ml1rem w2rem"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 310 310"
        >
            <g id="XMLID_801_">
                <path
                    className="fa-primary"
                    id="XMLID_802_"
                    d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
    C77.16,101.969,74.922,99.73,72.16,99.73z"
                />
                <path
                    className="fa-secondary"
                    id="XMLID_803_"
                    d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
    c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z"
                />
                <path
                    className="fa-primary"
                    id="XMLID_804_"
                    d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
    c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
    c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
    C310,145.43,300.549,94.761,230.454,94.761z"
                />
            </g>
        </svg>,
    },
    {
        identifier: 'title', type: 'text', placeholder: 'Title', className: "pl4rem shadow bg5 w100 br5px p1rem",
        index: 5,
        svg:
            <svg
                className="center-vertically f3 pa l0 ml1rem w2rem"
                viewBox="0 0 640 512"
            >
                <path
                    d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z"
                    className="fa-secondary"
                ></path>
            </svg>,
    },

]

export default function LeadAllocation({ profileClass, companies, advisors, getAuditLogs, setRefresh, getAdvisors }) {
    const dispatch = useDispatch();
    let user = useSelector((state) => state.user);
    let modal = useSelector((state) => state.modal);
    let [selectedData, setSelectedData] = useState('')
    let [advisorData, setAdvisorData] = useState('')
    let [uploadProfileModal, setUploadProfileModal] = useState(false)
    let [userProfile, setUserProfile] = useState('')
    let [loading, setLoading] = useState(false)
    let [currentFocus, setCurrentFocus] = useState(null);
    let inputRefs = useRef([]);
    let [permissions, setPermissions] = useState({})
    let [selectAll, setSelectAll] = useState(false);
    let [resendAdvisor, setResendAdvisor] = useState({})

    const [sections, setSections] = useState([
        { sectionNo: "D001", sectionName: "Key Shareholder/Investor Documents" },
        { sectionNo: "D002", sectionName: "Commercial Activities" },
        { sectionNo: "D003", sectionName: "Legal" },
        { sectionNo: "D004", sectionName: "Property" },
        { sectionNo: "D005", sectionName: "Intellectual Property" },
        { sectionNo: "D006", sectionName: "Insurance" },
        { sectionNo: "D007", sectionName: "Corporate Structure" },
        { sectionNo: "D008", sectionName: "State Aid" },
        { sectionNo: "D009", sectionName: "Finance" },
        { sectionNo: "D010", sectionName: "General Data Protection Regulations (GDPR)", },
        { sectionNo: "D011", sectionName: "Shares & Share Options" },
        { sectionNo: "D012", sectionName: "Taxation" },
        { sectionNo: "D013", sectionName: "Social Media" },
        { sectionNo: "D014", sectionName: "Key People" },
        { sectionNo: "D015", sectionName: "Human Resources" },
        { sectionNo: "D016", sectionName: "Environmental, Social & Governmental (ESG)", },
        { sectionNo: "D017", sectionName: "Key Advisors - Engagement Letters & Corrrspondence", },
        { sectionNo: "D018", sectionName: "IT Systems" },
        { sectionNo: "D019", sectionName: "Regulatory" },
        { sectionNo: "D020", sectionName: "Standards" },
        { sectionNo: "DEPF005", sectionName: "Environmental, Social, Governmental (ESG)", },
        { sectionNo: "DEPF006", sectionName: "Warranty Disclosure" },
        { sectionNo: "DEPF007", sectionName: "Directors Questionnaire" },
        { sectionNo: "DEPN004", sectionName: "Software Development" },
    ])

    useEffect(() => {
        let sectionObj = JSON.parse(JSON.stringify(sections));
        for (let company of companies) {
            const userType = 'revenuelead'
            if (company?.[userType]) {
                for (let advisorId of Object.keys(company?.[userType])) {
                    let advisorSettings = company?.[userType]?.[advisorId];
                    let advisor = advisors.find(({ _id }) => _id == advisorId);
                    if (!advisorSettings["modules"] || !advisor) continue;
                    sectionObj = sectionObj.map((obj, i, arr) => {
                        return {
                            ...obj,
                            allocation: { ...obj?.allocation, [company["_id"]]: { ...obj?.allocation?.[company["_id"]], [advisorId]: { ...advisor, allocationModule: advisorSettings["modules"] } } },

                        }
                    })
                }
            }
        }
        setSections(sectionObj)
    }, [companies])

    // on advisor allocation
    const handleLeadAllocation = async (e, advisor, sectionNo, company) => {
        if (advisor['emailVerified']) {
            const res = await postRequest(`/user/allocateRevenueLead/${company["_id"]}`, {
                advisor,
                company,
                advisorId: advisor["_id"],
                sectionNo,
                status: e["target"]["checked"],
                firmId: user["companyId"]["_id"],
            }
            );
            if (res && res["code"] == 200) {
                let sectionObj = await JSON.parse(JSON.stringify(sections));
                let sectionIndex = sections.findIndex((section) => section["sectionNo"] == sectionNo);
                Object.entries(sectionObj[sectionIndex]["allocation"][company["_id"]]).map((adv) => {
                    const key = adv[0]
                    const advData = adv[1]
                    sectionObj[sectionIndex]["allocation"][company["_id"]] = {
                        ...sectionObj[sectionIndex]["allocation"]?.[company["_id"]],
                        [advData["_id"]]: {
                            ...advData,
                            ['allocationModule']: {
                                ...advData,
                                [sectionNo]: key === advisor._id ? e["target"]["checked"] : false
                            }
                        }
                    }
                })

                setSections(sectionObj);
                showMessage(res["message"]);
                setRefresh((r) => !r);
            }
        }
        else {
            setResendAdvisor(advisor);
            dispatch(toggleModal({ open: "resendInviteMail" }));
        }
    };


    function arraysMatch(data, allList) {
        const allDataInAllList = data.every(item => allList.includes(item));
        const allAllListInData = allList.every(item => data.includes(item));
        return allDataInAllList && allAllListInData;
    }


    const checkAdvisorHasAllAllocations = ({ advisor, company }) => {

        if (advisor && company['revenuelead'] && company['revenuelead'][`${advisor['_id']}`] && company['revenuelead'][`${advisor['_id']}`]['modules']) {
            const allAllocationCode = sections.map((item) => item.sectionNo)
            const advisorPermission = []
            Object.entries(company['revenuelead'][`${advisor['_id']}`]['modules']).map((item) => item[1] === true && advisorPermission.push(item[0]))
            const result = arraysMatch(allAllocationCode, advisorPermission)
            return result
        }
        return false
    }

    // on advisor multi allocation
    const handleMultiLeadAllocation = async (e, advisor, sectionNo, company) => {
        if (advisor['emailVerified']) {

            const _checked = e["target"]["checked"];

            if (_checked === true) {
                if (checkAdvisorHasAllAllocations(advisor, company) === true) {
                    return showMessage('Already Selected a advisor for all');
                }
            }

            const result = await postRequest(`/user/advisorMultiPermissions/${company["_id"]}`, {
                advisor,
                company,
                advisorId: advisor["_id"],
                sectionNo,
                status: _checked,
                firmId: user["companyId"]["_id"],
            });

            const res = await postRequest(`/user/allocateMultiRevenueLead/${company["_id"]}`, {
                advisor,
                company,
                advisorId: advisor["_id"],
                sectionNo,
                status: _checked,
                firmId: user["companyId"]["_id"],
            });

            if (res && res["code"] == 200) {
                let sectionObj = await JSON.parse(JSON.stringify(sections));
                sections.map((_, sectionIndex) => {
                    if (!sectionObj[sectionIndex]["allocation"][company["_id"]][advisor["_id"]]) {
                        sectionObj[sectionIndex]["allocation"][company["_id"]] = { ...sectionObj[sectionIndex]["allocation"]?.[company["_id"]], [advisor["_id"]]: advisor, };
                    }
                })
                setSections(sectionObj);
            } else {
                // delete sectionObj[sectionIndex]["allocation"]?.[company["_id"]]?.[advisor["_id"]];
            }

            showMessage(res["message"]);
            setRefresh((r) => !r);

        } else {
            setResendAdvisor(advisor);
            dispatch(toggleModal({ open: "resendInviteMail" }));
        }
    };

    // on edit button Click in  bussiness card
    const onEditHandler = async (advisor) => {
        if (!advisor?.['permissions']) return
        const permissionArray = Object?.values(advisor?.['permissions']);
        if (advisor) {
            setAdvisorData({
                firstName: advisor["firstName"],
                lastName: advisor["lastName"],
                email: advisor["email"],
                title: advisor["designation"],
                isDisable: user?._id === advisor?._id ? false : true,
                isSuperUser: user?.["createdBy"] ? false : true,
                phone: advisor["phone"] && advisor["phone"] !== undefined && advisor["phone"] !== 'undefined' ? advisor["phone"] : '+44',
                linkedIn: advisor["linkedIn"] ? advisor["linkedIn"] : '',
                profile: advisor["profile"] ? advisor["profile"] : ''
            });
            if (!permissionArray.includes(false)) { setSelectAll(true) }
            if (advisor["permissions"]) setPermissions(advisor["permissions"]);
        }
    };

    // on edit modal close
    const onModalClose = () => setAdvisorData('');

    // on advisor submit
    const onSubmitAdvisor = async () => {
        if (advisorData["firstName"] == "")
            return showMessage("Enter your first name");
        if (advisorData["lastName"] == "")
            return showMessage("Enter your last name");
        if (advisorData["email"] == "") return showMessage("Enter your email");
        if (advisorData["designation"] == "") return showMessage("Enter your title");
        advisorData = await { ...advisorData, action: 'edit', permissions };

        const res = await postRequest(`/user/addAdvisor`, advisorData);
        if (res && res["code"] == 200) {
            await getAdvisors();
            showMessage(res["message"]);
            onModalClose()
            setSelectedData('')
        }
    }

    // on Fields changed
    const handleChange = (e) => {
        setAdvisorData({ ...advisorData, [e.target.name]: e.target.value });
    }

    // on Upload modal close
    const onUploadModalClose = () => {
        setUploadProfileModal(false)
    }

    // on Resent invite link to advisor modal close
    const onResendLinkModalClose = () => {
        setResendAdvisor({})
        dispatch(toggleModal({ open: "" }))
    }

    //Upload the profile image
    const handleProfile = async (e) => {
        let profile = e.target.files[0];
        if (profile && profile.size > 5 * 1024 * 1024)
            return showMessage("Photo Size must be less than 5MB");
        profile = URL.createObjectURL(profile);
        setUserProfile(profile);
    }

    // get image url to api submit
    const getImageUrl = async () => {
        let attachment = [];
        if (cropper.current && userProfile) {
            setLoading(true)
            let imageToUpload = cropper?.current?.getCroppedCanvas()?.toDataURL();
            let res = await fetch(imageToUpload);
            let blob = await res.blob();
            const coverFile = new File([blob], "profile image", {
                type: "image/png",
            });
            attachment.push(coverFile);
            const response = await postRequest(`/user/upload/advisor/profile`, { attachment });
            if (response || response["code"] == 200) {
                setAdvisorData({ ...advisorData, profile: response?.message })
            } else { setLoading(false) }
            setUserProfile('');
            onUploadModalClose()
            setLoading(false)
        }
        else {
            showMessage("Please upload image first")
        }
    };

    // Ensure the currently focused input keeps the focus
    useEffect(() => {
        if (currentFocus !== null) {
            inputRefs.current?.[currentFocus]?.focus();
        }
    }, [advisorData, currentFocus]);

    // on Focus function
    const handleFocus = (index) => setCurrentFocus(index);

    //handle Permissions section
    const handleAdvisorPermissions = async (e, section) => {
        if (e.target.checked === false) {
            setSelectAll(false)
        }
        permissions = await {
            ...permissions,
            [section["sectionNo"]]: e.target.checked,
        };
        await setPermissions(permissions);
        const permissionArray = Object.values(permissions);
        if (!permissionArray.includes(false)) {
            setSelectAll(true)
        }
    };

    // Select All Permissions
    const selectAllPermissions = (event) => {
        if (event.target.checked) {
            setSelectAll(event.target.checked);
            sections?.forEach((section) => {
                if (section.sectionNo.trim() !== "")
                    permissions[section.sectionNo] = event.target.checked;
            });
            setPermissions(permissions);
        }
        else {
            setSelectAll(false);
            sections?.forEach((section) => {
                if (section.sectionNo.trim() !== "")
                    permissions[section.sectionNo] = false;
            });
            setPermissions(permissions);
        }
    };

    // Send invitation link to advisor
    const submitResendInvite = async () => {
        const res = await getRequest(
            `/user/resendAdvisorInvite/${resendAdvisor["_id"]}`
        );
        if (res && res["code"] == 200) {
            dispatch(toggleModal({ open: "" }));
            showMessage(res["message"]);
            onResendLinkModalClose()
        }
    };

    const hasAdvisorPermission = (advisorData, company, sectionNo) => {
        if (company?.advisors?.[advisorData?.["_id"]]?.modules?.[sectionNo]) {
            return true
        }
        return false
    };

    return (
        <div className="sectionWrapper p1rem fs0-75rem pr mr2rem ml1rem">
            {companies && companies.length > 0 ? (
                <>
                    <div onClick={() => getAuditLogs(`/user/allocateRevenueLead`, user["companyId"]["_id"], "allocation")} className="df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard pa t0 r0 audit-log-btn" >
                        <span className='bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic'>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z" fill="#4A67FF" />
                            </svg>
                        </span>
                        <span className='c15'>Audit Log</span>
                    </div>
                    <div className="table-permission">
                        <table
                            id="table"
                            className="table-userPermissions table-clientPermissions 1"
                        >
                            <thead className="ps t0">
                                <tr>
                                    <th className="index-table">Modules</th>
                                    {companies &&
                                        companies.filter((company) => company['progress'] !== "inActive").map((company, compIndex) => {
                                            return (
                                                <th className="user-area" key={compIndex}>
                                                    <div className="df jcc aic">
                                                        <div className="mr1rem wfull pr">
                                                            <span className="df fs1rem c2">
                                                                {company["cName"]}
                                                                {company["subscription"] ? (
                                                                    <p className="c7 ml0-5rem">
                                                                        ({company["subscription"]?.toUpperCase()})
                                                                    </p>
                                                                ) : (
                                                                    <>
                                                                        <p className="c8 ml0-5rem">(INACTIVE)</p>
                                                                    </>
                                                                )}
                                                            </span>

                                                            <label className="pa r0 t0 df jcc aic">
                                                                {/* <InputLabel id="demo-simple-select-label">Apply to all Sections</InputLabel> */}
                                                                <Select
                                                                    multiple
                                                                    labelId="demo-simple-select-label"
                                                                    className="select-advisor w10 pa"
                                                                    id="demo-multiple-name"
                                                                    sx={{ "& .MuiSvgIcon-root": { color: "#4A67FF" }, "& .MuiSelect-select": '#000' }}
                                                                    IconComponent={ExpandMoreIcon}
                                                                    value={[]}
                                                                    label="Apply to all Sections"
                                                                    MenuProps={{
                                                                        anchorOrigin: {
                                                                            vertical: "bottom",
                                                                            horizontal: "right",
                                                                        },
                                                                        transformOrigin: {
                                                                            vertical: "top",
                                                                            horizontal: "right",
                                                                        },
                                                                        getContentAnchorEl: null,
                                                                    }}
                                                                >
                                                                    {advisors.map((advisor, adIdx) => {
                                                                        return (
                                                                            <MenuItem
                                                                                disabled={!advisor?.createdBy}
                                                                                key={adIdx}
                                                                                value={advisor}
                                                                                className="select-advisor-list ttc"

                                                                            >
                                                                                <div className={`${!hasValidAdvisor(advisor) && "disable-advisor-checkbox"}`}>
                                                                                    <Checkbox
                                                                                        disabled={!hasValidAdvisor(advisor)}
                                                                                        checked={checkAdvisorHasAllAllocations({ advisor, company })}
                                                                                        onClick={(e) => handleMultiLeadAllocation(e, advisor, sections.map((item) => item.sectionNo), company)}
                                                                                    />
                                                                                </div>
                                                                                <ListItemText
                                                                                    style={{ color: !hasValidAdvisor(advisor) && "lightgray" }}
                                                                                    primary={
                                                                                        advisor["firstName"] +
                                                                                        " " +
                                                                                        advisor["lastName"] +
                                                                                        " - " +
                                                                                        (advisor["designation"] ? advisor["designation"] : advisor["job"])
                                                                                    }
                                                                                />
                                                                                <div className="ml0-5rem">
                                                                                    {
                                                                                        hasValidAdvisor(advisor) ? <UserIcon
                                                                                            color={'#008000'}
                                                                                            onClick={() => setSelectedData({ ...advisor, hasEditButton: true, editRoute: "edit", })}
                                                                                        /> : <UserCloseIcon
                                                                                            color={'#F44336'}
                                                                                            onClick={() => setSelectedData({ ...advisor, hasEditButton: true, editRoute: "edit", })}
                                                                                        />
                                                                                    }
                                                                                </div>
                                                                            </MenuItem>
                                                                        )
                                                                    })}

                                                                </Select>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </th>
                                            );
                                        })}
                                </tr>
                            </thead>
                            <tbody>
                                {sections.map((section, idx) => {
                                    return (
                                        <tr>
                                            {/* Map Sections */}
                                            <td className="c15" key={idx}>
                                                <span className="fw600">{section["sectionNo"]}</span>{" "}
                                                {section["sectionName"]}
                                            </td>
                                            {/* Map Advisor allocation */}
                                            {companies &&
                                                companies.filter((company) => company['progress'] !== "inActive").map((company, idxx) => {
                                                    return (
                                                        <td className="c15 cp" key={`${idxx}-${company['_id']}-${new Date().getTime()}`} >
                                                            <div className="w100 df jcsb bg1 p0-5rem br30px" style={{ border: '1px solid #DBDFEE' }}>
                                                                <div className="df">
                                                                    {section?.["allocation"]?.[company["_id"]] &&
                                                                        Object.values(
                                                                            section["allocation"][company["_id"]]
                                                                        ).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                                                                            .map((advisor, indexNum) => {

                                                                                //Logic to show main advisor as active if there are no any advisor alligned to any section
                                                                                let parentActive = advisors.filter((advisorObj, advisorindex, arr) => {
                                                                                    if (
                                                                                        section?.["allocation"]?.[company["_id"]]?.[advisorObj["_id"]]?.allocationModule?.[section["sectionNo"]] === true && advisorObj?.["createdBy"]
                                                                                    ) {
                                                                                        return false
                                                                                    }
                                                                                    return true
                                                                                }).length < advisors?.length ? false : true

                                                                                return (
                                                                                    <React.Fragment key={`${company["_id"]}-${advisor?.["_id"]}-${indexNum}-${"advisorindex"}-${new Date().getTime()}`}>
                                                                                        {advisor?.["createdBy"] ? (
                                                                                            hasValidAdvisor(advisor) && hasAdvisorPermission(advisor, company, section["sectionNo"]) &&
                                                                                            <img
                                                                                                style={{
                                                                                                    border: section?.["allocation"]?.[
                                                                                                        company["_id"]
                                                                                                    ]?.[advisor["_id"]]?.allocationModule?.[section["sectionNo"]] === true ? '4px solid #09b255' : '4px solid transparent'
                                                                                                }}
                                                                                                key={`${company["_id"]}-${advisor?.["_id"]}-${indexNum}-${"advisorindex"}`}
                                                                                                className={`w2rem h2rem df jcc aic br100 mr0-5rem pr ${profileClass}`}
                                                                                                src={advisor["profile"] ? advisor["profile"] : require("../../../images/profile-photo.jpeg")}
                                                                                                onClick={(e) => handleLeadAllocation(
                                                                                                    e = {
                                                                                                        target: {
                                                                                                            checked: !section?.["allocation"]?.[company["_id"]]?.[advisor["_id"]]?.allocationModule?.[section["sectionNo"]]
                                                                                                        }
                                                                                                    },
                                                                                                    advisor,
                                                                                                    section["sectionNo"],
                                                                                                    company
                                                                                                )}
                                                                                                data-tooltip={
                                                                                                    advisor?.["firstName"]
                                                                                                        ? advisor["firstName"] +
                                                                                                        " " +
                                                                                                        advisor["lastName"]
                                                                                                        : "Register to show your name here"
                                                                                                }
                                                                                            />

                                                                                        ) : (
                                                                                            <img
                                                                                                style={{
                                                                                                    // border: '5px solid green',
                                                                                                    border: `4px solid ${parentActive ? "#09b255" : 'transparent'}`,
                                                                                                    background: "gray",
                                                                                                }}
                                                                                                className={`w2rem h2rem df jcc aic br100 mr0-5rem pr cna ${profileClass}`}
                                                                                                src={advisor["profile"] ? advisor["profile"] : require("../../../images/profile-photo.jpeg")}
                                                                                                data-tooltip={
                                                                                                    advisor["firstName"]
                                                                                                        ? advisor["firstName"] +
                                                                                                        " " +
                                                                                                        advisor["lastName"] + " " + `(Super Advisor)`
                                                                                                        : "Register to show your name here"
                                                                                                }
                                                                                            />
                                                                                        )}
                                                                                    </React.Fragment>
                                                                                );
                                                                            })}
                                                                </div>
                                                                <div className="pr">
                                                                    <Select
                                                                        multiple
                                                                        className="select-advisor w10"
                                                                        id="demo-multiple-name"
                                                                        sx={{ "& .MuiSvgIcon-root": { color: "#4A67FF" } }}
                                                                        IconComponent={ExpandMoreIcon}
                                                                        value={[]}
                                                                        MenuProps={{
                                                                            anchorOrigin: {
                                                                                vertical: "bottom",
                                                                                horizontal: "right",
                                                                            },
                                                                            transformOrigin: {
                                                                                vertical: "top",
                                                                                horizontal: "right",
                                                                            },
                                                                        }}
                                                                        disablePortal
                                                                    >
                                                                        {advisors.map((advisor, idx) => (
                                                                            hasAdvisorPermission(advisor, company, section["sectionNo"]) &&
                                                                            <MenuItem
                                                                                // disabled={!advisor?.createdBy}
                                                                                key={`dropdown-for-each-${idxx}-user-${idx}`}
                                                                                value={advisor}
                                                                                className="select-advisor-list ttc"
                                                                            >

                                                                                <div className={`${!hasValidAdvisor(advisor) && "disable-advisor-checkbox"}`}>
                                                                                    <Checkbox
                                                                                        checked={section?.["allocation"]?.[company["_id"]]?.[advisor["_id"]]?.allocationModule?.[section["sectionNo"]] === true ? true : false
                                                                                        }
                                                                                        disabled={!hasValidAdvisor(advisor)}
                                                                                        onClick={(e) => handleLeadAllocation(
                                                                                            e = {
                                                                                                target: {
                                                                                                    checked: !section?.["allocation"]?.[company["_id"]]?.[advisor["_id"]]?.allocationModule?.[section["sectionNo"]]
                                                                                                }
                                                                                            },
                                                                                            advisor,
                                                                                            section["sectionNo"],
                                                                                            company
                                                                                        )}
                                                                                    />
                                                                                </div>
                                                                                <ListItemText
                                                                                    style={{ color: !hasValidAdvisor(advisor) && "lightgray" }}
                                                                                    primary={
                                                                                        advisor["firstName"] +
                                                                                        " " +
                                                                                        advisor["lastName"] +
                                                                                        " - " +
                                                                                        `${(advisor["designation"] ? advisor["designation"] : advisor["job"])}`
                                                                                    }
                                                                                />
                                                                                <div className="ml0-5rem">
                                                                                    {
                                                                                        hasValidAdvisor(advisor) ? <UserIcon
                                                                                            color={'#008000'}
                                                                                            onClick={() => setSelectedData({ ...advisor, hasEditButton: true, editRoute: "edit", permission: section?.permission })}
                                                                                        /> : <UserCloseIcon
                                                                                            color={'#F44336'}
                                                                                            onClick={() => setSelectedData({ ...advisor, hasEditButton: true, editRoute: "edit", permission: section?.permission })}
                                                                                        />
                                                                                    }
                                                                                </div>
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    );
                                                })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                <div className="df jcc c15 fs1-75rem fw500 lh2 mt2rem">
                    No clients added for permissions
                </div>
            )
            }

            {/* Business Card Modal */}
            <Modal
                open={selectedData}
                onClose={() => setSelectedData('')}
                className="td500 zi4 pf t0 l0 w100 h110vh df jcc aic"
            >
                <BusinessCards
                    setSelectedData={setSelectedData}
                    selectedData={selectedData}
                    onEditClick={() => onEditHandler(selectedData)}
                    profileClass={profileClass}
                    user={user}
                />
            </Modal >

            {/* Add/Edit/Delete Advisor */}
            <Modal
                open={advisorData}
                onClose={onModalClose}
                className="backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic"
            >
                <div className="mah70 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw700px br5px pr">

                    {/* Logo */}
                    <img
                        className="h2rem pa t0 center-horizontally"
                        src={require(`../../../images/logo.svg`)}
                        alt="TODO"
                        style={{ top: "15px" }}
                    />

                    {/* Cross Button */}
                    <button
                        className="close-popup"
                        onClick={onModalClose}
                    >
                        <svg
                            style={{ position: "relative", top: "4px" }}
                            className="pen fds h1rem f1 mr0-5rem"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                className="pen fa-primary"
                                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            />
                        </svg>
                    </button>

                    {/* Modal Heading */}
                    <h1 className="text-gradient fs2rem fw600 tac ttu ">Edit Advisor</h1>
                    <div className="df fdc gg1rem px2rem">
                        <>
                            <UploadSection advisorData={advisorData} profileClass={profileClass} onProfileImageHandler={() => setUploadProfileModal(true)} />
                            <div className="dg gtcr2-md gg1rem">
                                {EDIT_FORM.slice(0, 2).map((obj, i, arr) => {
                                    return (
                                        <div className="pr" key={obj?.identifier}>
                                            <input
                                                value={advisorData?.[obj?.identifier]}
                                                name={obj?.identifier}
                                                ref={(el) => inputRefs.current[obj?.index] = el}
                                                type={obj?.type}
                                                placeholder={obj?.placeholder}
                                                onChange={(e) => handleChange(e)}
                                                className={obj?.className}
                                                onFocus={() => handleFocus(obj?.index)}
                                            />
                                            {obj?.svg}
                                        </div>
                                    )
                                })}
                            </div>
                            {
                                EDIT_FORM.slice(2).map((obj, i, arr) => {
                                    return (
                                        <div className="pr" key={obj?.identifier}>
                                            {
                                                obj?.component ?
                                                    <>
                                                        <Input
                                                            className={obj.className}
                                                            name={obj.identifier}
                                                            country={obj?.country}
                                                            ref={(el) => inputRefs.current[obj?.index] = el}
                                                            international={obj?.international}
                                                            withCountryCallingCode={obj?.withCountryCallingCode}
                                                            value={advisorData?.[obj?.identifier] ? advisorData?.[obj?.identifier] : ''}
                                                            onChange={(e) => setAdvisorData({ ...advisorData, phone: e })}
                                                            onFocus={() => handleFocus(obj?.index)}
                                                        />
                                                        {obj?.svg}
                                                    </>
                                                    :
                                                    <>
                                                        <input
                                                            disabled={obj?.disabled}
                                                            value={advisorData?.[obj?.identifier]}
                                                            name={obj?.identifier}
                                                            type={obj?.type}
                                                            ref={(el) => inputRefs.current[obj?.index] = el}
                                                            placeholder={obj?.placeholder}
                                                            onChange={(e) => handleChange(e)}
                                                            className={obj?.className}
                                                            onFocus={() => handleFocus(obj?.index)}
                                                        />
                                                        {obj?.svg}
                                                    </>
                                            }
                                        </div>
                                    )
                                })
                            }

                        </>
                        <div className="my1rem">
                            {/* All Permissions */}
                            <div className="df my0-5rem">
                                <span className="checkbox w2rem h2rem pr">
                                    <input
                                        checked={selectAll}
                                        onChange={selectAllPermissions}
                                        id="all-permissions"
                                        className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px"
                                        type="checkbox"
                                    />
                                </span>
                                <span className="fs1rem fw600 mx1rem usn">All</span>
                                <span className="fs1rem fw400 usn">Permissions</span>
                            </div>
                            {/* Sections Permissions */}
                            {sections &&
                                sections.map((section) => {
                                    return (
                                        <div className="df my0-5rem">
                                            <span className="checkbox w2rem h2rem pr">
                                                <input
                                                    defultChecked={permissions[section["sectionNo"]]}
                                                    checked={permissions[section["sectionNo"]]}
                                                    onChange={(e) => handleAdvisorPermissions(e, section)}
                                                    id={`permissions-${section["sectionNo"]}`}
                                                    className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px"
                                                    type="checkbox"
                                                />
                                            </span>
                                            <span className="fs1rem fw600 mx1rem usn">
                                                {section["sectionNo"]}
                                            </span>
                                            <span className="fs1rem fw400 usn">
                                                {section["sectionName"]}
                                            </span>
                                        </div>
                                    );
                                })}
                        </div>
                        <span onClick={onSubmitAdvisor} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac df jcc aic">
                            Save
                        </span>
                        <span onClick={onModalClose} className="c3-hover td250 fs1-25rem cp">
                            Cancel
                        </span>
                    </div>
                </div>
            </Modal >


            {/* Upload Profile */}
            < Modal
                open={uploadProfileModal}
                onClose={onUploadModalClose}
                className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic"
            >
                <div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
                    <button
                        className="close-popup"
                        onClick={onUploadModalClose}
                    >
                        <svg
                            style={{ position: "relative", top: "4px" }}
                            className="pen fds h1rem f1 mr0-5rem"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                className="pen fa-primary"
                                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            />
                        </svg>
                    </button>

                    <h1 className="text-gradient fs2rem tac lh1 fw600 mb2rem">
                        Upload Profile Picture
                    </h1>
                    {userProfile == "" ? (
                        <label
                            for="profile"
                            className="w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area"
                        >
                            <span className="pen fs1rem fw500 tac">Upload picture</span>
                            <br />
                            <div className="">
                                <input
                                    className=""
                                    onChange={handleProfile}
                                    id="profile"
                                    type="file"
                                    accept="image/jpeg, image/jpg, image/png"
                                />
                            </div>
                            <label>Max file size 5MB</label>
                        </label>
                    ) : (
                        <div className="img-box pr">
                            <Cropper
                                style={{ maxHeight: "500px" }}
                                ref={cropper}
                                guides={false}
                                aspectRatio={1 / 1}
                                className="cropper-settings"
                                src={userProfile}
                            />
                        </div>
                    )}
                    <div className="df jcse">
                        <span onClick={() => { setUserProfile(""); setUploadProfileModal(false) }}
                            className="shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem"
                        >
                            Cancel
                        </span>
                        <span
                            onClick={() => { if (!loading) getImageUrl() }}
                            className={`shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem ${loading && "button-disabled"}`}
                        >
                            {Object.keys(userProfile).length == 0
                                ? "Upload"
                                : "Crop & Upload"}
                        </span>
                    </div>
                </div>
            </Modal >

            {/* Resend Invite Advisor */}
            < Modal
                open={modal["open"] == "resendInviteMail"}
                onClose={onResendLinkModalClose}
                className="backdrop td500 zi4 pf t0 l0 w100 h110vh df jcc aic"
            >
                <div className="mah90 oya bg1 shadow w100 px2rem py3rem bsbb df fdc m1rem maw600px br5px pr">
                    <img
                        className="h2rem pa t0 center-horizontally"
                        src={require(`../../../images/logo.svg`)}
                        alt="TODO"
                        style={{ top: "15px" }}
                    />
                    <button
                        className="close-popup"
                        onClick={onResendLinkModalClose}
                    >
                        <svg
                            style={{ position: "relative", top: "4px" }}
                            className="pen fds h1rem f1 mr0-5rem"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512"
                        >
                            <path
                                className="pen fa-primary"
                                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            />
                        </svg>
                    </button>
                    <h1 className="text-gradient fs2rem fw600 tac ttu pt1rem">
                        Resend Invite
                    </h1>
                    <div className="df fdc gg1rem px2rem">
                        <p className="fs1rem py1rem tac">
                            <>Advisor <span className="fw600 ttc">{resendAdvisor["firstName"]} {resendAdvisor["lastName"]}</span> is currently
                                <span className="fw600 ttc"> Inactive</span>. Please send <span className="fw600 ttc">{resendAdvisor["firstName"]} {resendAdvisor["lastName"]}
                                </span> an
                                invitation link to activate their account, enabling you to allocate them to any department</>
                        </p>
                        <div className="df jcsa">
                            <span
                                onClick={onResendLinkModalClose}
                                className="w30 shadow bg4 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic"
                            >
                                Cancel
                            </span>
                            <span
                                onClick={submitResendInvite}
                                className="w30 shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic"
                            >
                                Send
                            </span>
                        </div>
                    </div>
                </div>
            </Modal >
        </div >
    );
}



